'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  PENDING_REJECT: 'PENDING_REJECT',
  RECEIVED: 'RECEIVED',
  REJECTED: 'REJECTED',
  SENT: 'SENT'
};